import { FC } from 'react';
import { Button } from '../ui/Button';

interface ErrorFallbackProps {
  error: Error;
  componentStack: string | null;
  eventId: string | null;
  resetError: () => void;
}

export const SentryErrorFallback: FC<ErrorFallbackProps> = ({
  error,
  eventId,
  resetError,
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-danger-500/10 dark:bg-danger-500/20 rounded-lg border border-danger-500/20">
      <h2 className="text-lg font-semibold text-danger-600 dark:text-danger-400 mb-2">
        Something went wrong
      </h2>
      <p className="text-sm text-danger-500 dark:text-danger-400 mb-4 text-center max-w-md">
        {error.message || 'An unexpected error occurred'}
      </p>
      {eventId && (
        <p className="text-xs text-text-muted mb-4 font-mono">
          Error ID: {eventId}
        </p>
      )}
      <div className="flex gap-3">
        <Button variant="danger" onClick={resetError}>
          Try Again
        </Button>
        <Button
          variant="secondary"
          onClick={() => window.location.reload()}
        >
          Refresh Page
        </Button>
      </div>
    </div>
  );
};
